<template>
    <!-- <div class="widget widget-gray">
        <div class="widget-head">
            <h3 class="heading">{{ heading }}</h3>
        </div>
        <div class="widget-body">
          <slot></slot>
        </div>
    </div>  -->

    <b-card >
      <template slot="header" v-if="heading">
        <font-awesome-icon v-if="icon" :icon="icon" class="mr-2"/>
        <span>{{heading}}</span>
      </template>
      <slot></slot>
    </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    heading: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
.widget {
  margin: 0 auto 1em;
  border-bottom-color: #c1c2c3;
}

.widget.widget-gray {
  background: #fafafa;
  /* background: #f5f5f5; */
}
.widget.widget-gray > .widget-head {
  background: #e9e9e9;
  border-color: #d1d2d3;
  border-bottom-color: #990033;
  box-shadow: inset 1px 1px 1px rgba(255, 255, 255, 0.6),
    inset -1px -1px 1px rgba(0, 0, 0, 0);
  -moz-box-shadow: inset 1px 1px 1px rgba(255, 255, 255, 0.6),
    inset -1px -1px 1px rgba(0, 0, 0, 0);
  -webkit-box-shadow: inset 1px 1px 1px rgba(255, 255, 255, 0.6),
    inset -1px -1px 1px rgba(0, 0, 0, 0);
}
.widget.widget-gray > .widget-head .heading {
  /* color: #770033; */
  text-shadow: 0 1px 0 #fff;
}
.widget.widget-gray > .widget-head .heading.glyphicons i:before {
  background: none;
  color: #555;
  border-color: rgba(0, 0, 0, 0.1);
}
.card {
  margin: 0 auto 1em;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
